export enum TipoContratoEnum {
  NAO_INFORMADO = 0,
  ORDINARIO = 1,
  NOTA_DE_EMPENHO = 2,
}

// Mapeamento para exibição
export const TipoContratoLabels: Record<TipoContratoEnum, string> = {
  [TipoContratoEnum.NAO_INFORMADO]: 'Não informado',
  [TipoContratoEnum.ORDINARIO]: 'Ordinário',
  [TipoContratoEnum.NOTA_DE_EMPENHO]: 'Nota de empenho',
};

// Mapeamento para códigos/slugs
export const TipoContratoCodes: Record<TipoContratoEnum, string> = {
  [TipoContratoEnum.NAO_INFORMADO]: '',
  [TipoContratoEnum.ORDINARIO]: 'A',
  [TipoContratoEnum.NOTA_DE_EMPENHO]: 'B',
};

export const getTipoContratoOptions = () => {
  return Object.values(TipoContratoEnum)
    .filter((value) => typeof value === 'number')
    .map((value) => ({
      value: value as TipoContratoEnum,
      label: TipoContratoLabels[value as TipoContratoEnum],
      code: TipoContratoCodes[value as TipoContratoEnum],
    }));
};

export const getTipoContratoSlug = (tipoContrato: TipoContratoEnum): string => {
  return TipoContratoCodes[tipoContrato] || 'Desconhecido';
};

export const getTipoContratoLabel = (
  tipoContrato: TipoContratoEnum,
): string => {
  return TipoContratoLabels[tipoContrato] || 'Tipo ded Contrato Desconhecido';
};

export const getTipoContratoPorCodigo = (
  code: string,
): TipoContratoEnum | undefined => {
  const entry = Object.entries(TipoContratoCodes).find(
    ([, value]) => value === code,
  );
  return entry ? (Number(entry[0]) as TipoContratoEnum) : undefined;
};

export const getTipoContratoLabelPorSlug = (slug: string): string => {
  const tipoContrato = getTipoContratoPorCodigo(slug);

  if (tipoContrato !== undefined) {
    return getTipoContratoLabel(tipoContrato);
  }

  return 'Tipo de Contrato Desconhecido';
};
